var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.3335 6.66634C7.89147 6.66634 7.46755 6.84194 7.15498 7.1545C6.84242 7.46706 6.66683 7.89098 6.66683 8.33301V30.976L10.4883 27.1545C10.8009 26.8419 11.2248 26.6663 11.6668 26.6663H31.6668C32.1089 26.6663 32.5328 26.4907 32.8453 26.1782C33.1579 25.8656 33.3335 25.4417 33.3335 24.9997V8.33301C33.3335 7.89098 33.1579 7.46706 32.8453 7.1545C32.5328 6.84194 32.1089 6.66634 31.6668 6.66634H8.3335ZM4.79796 4.79747C5.73564 3.85979 7.00741 3.33301 8.3335 3.33301H31.6668C32.9929 3.33301 34.2647 3.85979 35.2024 4.79747C36.14 5.73516 36.6668 7.00692 36.6668 8.33301V24.9997C36.6668 26.3258 36.14 27.5975 35.2024 28.5352C34.2647 29.4729 32.9929 29.9997 31.6668 29.9997H12.3572L6.17867 36.1782C5.70201 36.6549 4.98515 36.7974 4.36236 36.5395C3.73957 36.2815 3.3335 35.6738 3.3335 34.9997V8.33301C3.3335 7.00693 3.86028 5.73516 4.79796 4.79747Z",
    fill: "#03E287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/message-square.8b8111e1134504aa4a16ae92a89c1e3b.svg";
export { ForwardRef as ReactComponent };